<ds-modal [modal]="modal" [title]="'cannot_move_digital_asset' | translate" [maxWidthPercentage]="80" (modalClosed)="onClose()">
  <div class="modal-content-wrapper">
    <p>{{ reason | translate }}</p>
    <div class="d-flex gap-3 mt-4">
      <button ds-button [variant]="DsButtonVariants.primary" (click)="onClose()">
        {{ 'got_it' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
